import { Phone } from "lucide-react";
import SectionHeading from "../components/SectionHeading";

const staff = [
  {
    key: "damon-johnson",
    name: "Damon Johnson",
    title: "Board President",
    division: "10U",
    phone: "(951) 401-3498",
    phoneHref: "tel:9514013498",
    avatar: "/assets/spartans/spartan-1.png",
    bio: "Leads the Titans front office and oversees the 10U program.",
    featured: true,
  },
  {
    key: "william-butler",
    name: "William Butler",
    title: "Vice President",
    division: "Board",
    phone: "(951) 442-7614",
    phoneHref: "tel:9514427614",
    avatar: "/assets/spartans/spartan-2.png",
    bio: "Keeps the organization running on and off the field.",
  },
  {
    key: "coach-ad",
    name: "Coach AD",
    title: "Head Coach",
    division: "8U",
    phone: "(619) 362-1441",
    phoneHref: "tel:6193621441",
    avatar: "/assets/spartans/spartan-3.png",
    bio: "Builds 8U fundamentals with precision and patience.",
  },
  {
    key: "coach-jones",
    name: "Coach Jones",
    title: "Head Coach",
    division: "12U · 13U",
    phone: "(951) 750-4018",
    phoneHref: "tel:9517504018",
    avatar: "/assets/spartans/spartan-4.png",
    bio: "Runs the upper divisions with a championship mindset.",
  },
  {
    key: "coach-myles",
    name: "Coach Myles",
    title: "Assistant Coach",
    division: "12U · 13U",
    phone: "(951) 590-1675",
    phoneHref: "tel:9515901675",
    avatar: "/assets/spartans/spartan-5.png",
    bio: "Develops linemen and skill players rep by rep.",
  },
  {
    key: "coach-darryl",
    name: "Coach Darryl",
    title: "Head Coach",
    division: "10U",
    phone: "(951) 728-3987",
    phoneHref: "tel:9517283987",
    avatar: "/assets/spartans/spartan-6.png",
    bio: "Drives 10U development through accountability and grit.",
  },
  {
    key: "coach-roc",
    name: "Coach Roc",
    title: "Head Coach",
    division: "8U",
    phone: "(323) 392-9669",
    phoneHref: "tel:3233929669",
    avatar: "/assets/spartans/spartan-7.png",
    bio: "Sparks the 8U squad with energy and old-school fundamentals.",
  },
  {
    key: "coach-walker",
    name: "Coach Walker",
    title: "Assistant Coach",
    division: "8U",
    phone: "(951) 404-4595",
    phoneHref: "tel:9514044595",
    avatar: "/assets/spartans/spartan-8.png",
    bio: "Trusted hands on the 8U sideline, building confidence one drill at a time.",
  },
  {
    key: "monica-freeman",
    name: "Monica Freeman",
    title: "Head Cheer Coach",
    division: "Cheer",
    phone: "(951) 502-8461",
    phoneHref: "tel:9515028461",
    avatar: "/assets/spartans/spartan-monica.png",
    bio: "Leads the Titans Cheer squad — spirit, strength, and unity. Ages 6–13.",
  },
  {
    key: "ariya-bennett",
    name: "Ariya Bennett",
    title: "Jr. Cheer Coach",
    division: "Cheer",
    phone: "(858) 833-2548",
    phoneHref: "tel:8588332548",
    avatar: "/assets/spartans/spartan-ariya.png",
    bio: "Coaches Jr. Titans Cheer — building confidence and technique from the ground up.",
  },
  {
    key: "shelby-cheer",
    name: "Shelby",
    title: "Assistant Cheer Coach",
    division: "Cheer",
    phone: "(951) 282-8329",
    phoneHref: "tel:9512828329",
    avatar: "/assets/spartans/spartan-shelby.png",
    bio: "Assistant Cheer Coach — helps the squad stay sharp, spirited, and in sync.",
  },
  {
    key: "autumn-andrews",
    name: "Autumn Andrews",
    title: "Cheer Coordinator",
    division: "Cheer",
    phone: "(951) 590-6349",
    phoneHref: "tel:9515906349",
    avatar: "/assets/spartans/spartan-autumn.png",
    bio: "Cheer program coordinator — first point of contact for cheer families.",
  },
];

export default function Coaches() {
  return (
    <div data-testid="coaches-page">
      <section className="py-20 md:py-28 bg-[#F5EFE0] border-b border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <SectionHeading
            eyebrow="Leadership · 2026 Season"
            title="Board & Coaching Staff"
            description="The faces behind the whistles. Tap to call — they're here for your athlete."
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 auto-rows-fr" data-testid="coaches-grid">
            {staff.map((c, idx) => (
              <CoachCard key={c.key} coach={c} rank={idx + 1} />
            ))}
          </div>

          {/* JOIN THE STAFF */}
          <div className="mt-20 bg-[#2D5F3F] text-[#FDFBF7] p-8 md:p-12" data-testid="join-staff-band">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
              <div className="md:col-span-2">
                <div className="font-display uppercase tracking-[0.3em] text-xs font-bold opacity-80">We Need You</div>
                <h3 className="mt-2 font-display text-3xl md:text-5xl font-black uppercase leading-tight">Coach &amp; Board Spots Are Open</h3>
                <p className="mt-4 text-[#FDFBF7]/85 max-w-2xl">
                  Whether you&apos;ve coached for years or want to support the team off the field, the Titans have a place for you.
                  Volunteer board roles, position coaches, and team-mom spots are all available.
                </p>
              </div>
              <a
                href="mailto:Cawstontitans@gmail.com"
                data-testid="join-staff-email"
                className="inline-flex items-center justify-center gap-2 bg-[#FDFBF7] hover:bg-[#0A0A0A] text-[#2D5F3F] hover:text-[#FDFBF7] font-display uppercase tracking-wider font-extrabold px-6 py-4 transition-colors text-center"
              >
                Cawstontitans@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function CoachCard({ coach, rank }) {
  const featured = coach.featured;

  // Color tokens for variants
  const cardCls = featured
    ? "bg-[#2D5F3F] border-2 border-[#2D5F3F] text-[#FDFBF7]"
    : "bg-white border-2 border-[#2D5F3F]/20 hover:border-[#2D5F3F]/60 text-[#0A0A0A]";

  const ringCls = featured ? "bg-[#FDFBF7] ring-4 ring-[#FDFBF7]/40" : "bg-[#EFE9D9] ring-4 ring-[#2D5F3F]/15";
  const titleCls = featured ? "text-[#FDFBF7]/80" : "text-[#2D5F3F]";
  const nameCls = featured ? "text-[#FDFBF7]" : "text-[#0A0A0A]";
  const bioCls = featured ? "text-[#FDFBF7]/85" : "text-black/70";
  const divisionBgCls = featured
    ? "bg-[#FDFBF7]/10 border-[#FDFBF7]/30 text-[#FDFBF7]"
    : "bg-[#EFE9D9] border-black/10 text-[#0A0A0A]";
  const divisionLabelCls = featured ? "text-[#FDFBF7]/70" : "text-[#2D5F3F]";
  const dividerCls = featured ? "border-[#FDFBF7]/20" : "border-black/10";
  const phoneWrapCls = featured
    ? "bg-[#FDFBF7] hover:bg-[#0A0A0A] text-[#2D5F3F] hover:text-[#FDFBF7]"
    : "bg-[#2D5F3F] hover:bg-[#1B4332] text-[#FDFBF7]";
  const phoneIconBg = featured ? "bg-[#2D5F3F]/10" : "bg-[#FDFBF7]/15";

  return (
    <article
      data-testid={`coach-card-${coach.key}`}
      className={`h-full flex flex-col p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_-10px_rgba(45,95,63,0.35)] ${cardCls}`}
    >
      {/* Rank pill */}
      <div className="flex items-center justify-between">
        <span
          className={`font-display text-[10px] uppercase tracking-[0.3em] font-extrabold px-2.5 py-1 ${
            featured ? "bg-[#FDFBF7] text-[#2D5F3F]" : "bg-[#2D5F3F] text-[#FDFBF7]"
          }`}
        >
          {String(rank).padStart(2, "0")}
        </span>
        {featured && (
          <span className="font-display text-[10px] uppercase tracking-[0.3em] font-extrabold text-[#FDFBF7]/80">
            President
          </span>
        )}
      </div>

      {/* 1. Spartan decal — centered at top, +40% size */}
      <div className="mt-4 flex justify-center">
        <div className={`w-32 h-32 md:w-36 md:h-36 flex items-center justify-center ${ringCls}`}>
          <img
            src={coach.avatar}
            alt={`${coach.name} decal`}
            className="w-[88%] h-[88%] object-contain p-1"
            draggable="false"
          />
        </div>
      </div>

      {/* 2. Coach title */}
      <div className={`mt-6 text-center font-display text-[11px] uppercase tracking-[0.35em] font-bold ${titleCls}`}>
        {coach.title}
      </div>

      {/* 3. Coach name — focal point */}
      <h3
        className={`mt-2 text-center font-display text-3xl md:text-4xl font-black uppercase leading-[1.05] ${nameCls}`}
      >
        {coach.name}
      </h3>

      {/* Bio removed */}

      {/* 4. Team / age group */}
      <div className="mt-5 flex justify-center">
        <div
          className={`inline-flex items-center gap-2 border px-3 py-1.5 ${divisionBgCls}`}
        >
          <span className={`text-[10px] font-display uppercase tracking-[0.25em] font-bold ${divisionLabelCls}`}>
            Coaches
          </span>
          <span className="font-display text-sm font-extrabold">{coach.division}</span>
        </div>
      </div>

      {/* Spacer pushes phone to bottom for alignment */}
      <div className="flex-1" />

      {/* 5. Phone — aligned at bottom across all cards */}
      <div className={`mt-6 pt-6 border-t ${dividerCls}`}>
        <a
          href={coach.phoneHref}
          data-testid={`coach-phone-${coach.key}`}
          className={`flex items-center justify-center gap-3 font-display uppercase tracking-wider font-extrabold text-sm px-4 py-3 transition-colors ${phoneWrapCls}`}
        >
          <span className={`w-7 h-7 flex items-center justify-center ${phoneIconBg}`}>
            <Phone className="w-3.5 h-3.5" strokeWidth={2.5} />
          </span>
          <span>{coach.phone}</span>
        </a>
      </div>
    </article>
  );
}
